import React from 'react';
import { Grid, Typography, TextField } from '@material-ui/core';

import { ClientContext } from '../../ClientContext';

export function ClientStockSymbol() {
    const clientContext = React.useContext(ClientContext);

    return (
        <Grid 
            container 
            direction="column" 
            spacing={3}>
            <Grid item xs={12}>
                <Typography variant="subtitle1">
                Dados econômicos
                </Typography>
            </Grid>
            <Grid item xs={12}>
                <TextField 
                    id='client-stock-symbol'
                    fullWidth
                    label="Código de negociação"
                    variant="outlined"
                    type="string" 
                    value={clientContext.stockSymbol}
                    onChange={(event) => clientContext.setStockSymbol(event.target.value)}
                    InputProps={{ value: clientContext.stockSymbol.toUpperCase() }}/>
            </Grid>
        </Grid>
    );
}